import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../components/DynamicCrudPage';
import { useTasks, useFirms, useCompanies, SCREENS } from '../../hooks';
import AddIcon from '@mui/icons-material/Add';

const TasksPage = () => {
  const { t } = useTranslation();

  const customFormFields = useCallback((fields, additionalData, isRootUser, t) => {
    const { companies, firms } = additionalData;
    const companiesList = companies?.companies || [];
    const firmsList = firms?.firms || [];

    return fields
      .map(field => {
        if (field.name === 'companyId') {
          return {
            ...field,
            options: companiesList.map(c => ({ value: c.id, label: c.name })),
            showIf: (formData) => isRootUser,
          };
        }
        if (field.name === 'firmId') {
          return {
            ...field,
            options: firmsList.map(f => ({ value: f.id, label: f.firm_name })),
          };
        }
        return field;
      });
  }, []);

  return (
    <DynamicCrudPage
      entityType="tasks"
      screen={SCREENS.TASKS}
      commentEntityType="task"
      hook={useTasks}
      additionalHooks={{
        firms: useFirms,
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addTask"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="task"
      customFormFields={customFormFields}
      showAddButton={true}
    />
  );
};

export default TasksPage;
